import {Injectable} from '@angular/core';
import {AppointmentTurn} from '@shared/models/appointment.model';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppoTurnService {
  private _dialogTurnSubject = new BehaviorSubject<AppointmentTurn>(null);

  getDialogTurnObservable(): Observable<AppointmentTurn> {
    return this._dialogTurnSubject.asObservable();
  }

  initDialogTurn(): void {
    this._dialogTurnSubject.next(null);
  }

  openDialogTurn(turn: AppointmentTurn): void {
    this._dialogTurnSubject.next(turn);
  }

  closeDialogTurn(): void {
    this._dialogTurnSubject.next(null);
  }
}
